const PrfPerformance = () => {
  const resizeSidebar = util.resizeSidebar;

  // Create an async function as a shorthand for resolving fetch requests
  async function fetchData(url) {
    const response = await fetch(url);
    const json = await response.json();
    return json;
  }

  /**
   * This function is used to generate the Upstream to Downstream table
   * @param {string} selector html selector for the table
   * @param {array} config array containg table config options for each field
   * @param {array} data array containing table data
   */
  function createUDStatsTable(selector, config, data) {
    const fields = config.map(d => d.id);

    document.querySelector(selector).innerHTML = "";

    const table = document.createElement("table");
    table.classList += "table margin-right";
    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");
    const tbody = document.createElement("tbody");

    // create the a header for each field
    config.forEach(header => {
      const th = document.createElement("th");
      th.textContent = header.label;
      headerRow.appendChild(th);
    });

    // loop through the data and populate the table
    // if data is numeric, round to one decimal
    data.forEach(d => {
      if (d !== null) {
        const tr = document.createElement("tr");
        fields.forEach(field => {
          const td = document.createElement("td");
          if (typeof d[field] === "number") {
            td.textContent = d[field].toFixed(1);
          } else {
            td.textContent = d[field];
          }
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      }
    });

    // append the table to the provided selector
    const target = document.querySelector(selector);
    thead.appendChild(headerRow);
    table.appendChild(thead);
    table.appendChild(tbody);
    target.appendChild(table);
  }

  /**
   * This function is used to calculate the values/stats
   * for the upstream to downstream concentrations table
   * @param {*} data
   */
  function calcUDStats(data) {
    const upstreamData = data.filter(d => d.endpoint_desc === "Upstream");
    const downstreamData = data.filter(d => d.endpoint_desc === "Downstream");
    let upstreamStats = null;
    let downstreamStats = null;
    let netStats = null;
    let pctStats = null;

    if (upstreamData.length > 0) {
      upstreamStats = {
        cat: `${upstreamData[0].location_name} (Upstream)`,
        avg: d3.mean(upstreamData, d => d.rvalue_converted),
        max: d3.max(upstreamData, d => d.rvalue_converted),
        min: d3.min(upstreamData, d => d.rvalue_converted),
        units: upstreamData[0].unit_name,
      };
    }

    if (downstreamData.length > 0) {
      downstreamStats = {
        cat: `${downstreamData[0].location_name} (Downstream)`,
        avg: d3.mean(downstreamData, d => d.rvalue_converted),
        max: d3.max(downstreamData, d => d.rvalue_converted),
        min: d3.min(downstreamData, d => d.rvalue_converted),
        units: upstreamData[0].unit_name,
      };
    }

    if (upstreamData.length > 0 && downstreamData.length > 0) {
      netStats = {
        cat: "Net Difference",
        avg: downstreamStats.avg - upstreamStats.avg,
        max: downstreamStats.max - upstreamStats.max,
        min: downstreamStats.min - upstreamStats.min,
        units: upstreamData[0].unit_name,
      };
      pctStats = {
        cat: "% Difference",
        avg:
          ((downstreamStats.avg - upstreamStats.avg) / upstreamStats.avg) * 100,
        max:
          ((downstreamStats.max - upstreamStats.max) / upstreamStats.max) * 100,
        min:
          ((downstreamStats.min - upstreamStats.min) / upstreamStats.min) * 100,
        units: upstreamData[0].unit_name,
      };
    }
    return [upstreamStats, downstreamStats, netStats, pctStats];
  } // calcUDStats()

  /**
   * This function is used to update the title for each graph whenever
   * the graph data changes
   * @param {*} units
   */
  function setGraphTitle(units) {
    const udGraphTitle = document.querySelector(
      "#upstream-downstream-concentrations-title"
    );
    const udNetChangeGraphTitle = document.querySelector(
      "#upstream-downstream-net-change-title"
    );
    const udGraphSubTitle = document.querySelector(
      "#upstream-downstream-concentrations-subtitle"
    );
    const udNetChangeGraphSubTitle = document.querySelector(
      "#upstream-downstream-net-change-subtitle"
    );
    const udPctChangeGraphSubTitle = document.querySelector(
      "#upstream-downstream-percent-change-subtitle"
    );

    udGraphTitle.textContent = `Upstream to Downstream Concentrations Over Time (${units})`;
    udNetChangeGraphTitle.textContent = `Net Change Over Time (${units})`;
    udGraphSubTitle.textContent = `${Parameter.text()} @ ${PRFs.text()}`;
    udNetChangeGraphSubTitle.textContent = `${Parameter.text()} @ ${PRFs.text()}`;
    udPctChangeGraphSubTitle.textContent = `${Parameter.text()} @ ${PRFs.text()}`;
  }

  function setLegend() {
    const udGraphLegend = document.querySelector(
      "#upstream-downstream-concentrations-legend"
    );
    const upstreamFilled = udGraphLegend.querySelector("#upstream-loc-filled");
    const upstreamHollow = udGraphLegend.querySelector("#upstream-loc-hollow");
    const downstreamFilled = udGraphLegend.querySelector(
      "#downstream-loc-filled"
    );
    const downstreamHollow = udGraphLegend.querySelector(
      "#downstream-loc-hollow"
    );

    upstreamFilled.textContent = `${activePRFLocs.upstreamLoc} - Base Flow`;
    upstreamHollow.textContent = `${activePRFLocs.upstreamLoc} - Storm Flow`;
    downstreamFilled.textContent = `${activePRFLocs.downstreamLoc} - Base Flow`;
    downstreamHollow.textContent = `${activePRFLocs.downstreamLoc} - Storm Flow`;
  }

  // initialize empty variables to hold the data for graphs
  let UDGraphData = [];
  let UDNetChangeGraphData = [];
  let UDPercentChangeGraphData = [];
  let activePRFLocs = {
    upstreamLoc: "CT-P1",
    downstreamLoc: "CT-2",
  };

  // Create the statistics summary table
  const statTableConfig = [
    { id: "cat", label: "Type" },
    { id: "avg", label: "Average" },
    { id: "max", label: "Max" },
    { id: "min", label: "Min" },
  ];

  // Create the start date filter
  const StartDate = new datePicker({
    container: "#start-date",
    elementExists: true,
    displayInline: true,
    onChange: () => {
      updateData();
    },
  }).setDate("2018-10-01");

  // create the end date filter
  const EndDate = new datePicker({
    container: "#end-date",
    elementExists: true,
    displayInline: true,
    onChange: () => {
      updateData();
    },
  }).setDate("2019-09-30");

  // create the parameter filter
  const PRFs = new Dropdown({
    container: "#prfs",
    elementExists: true,
    onChange: () => {
      updateData();
    },
  });

  // create the parameter filter
  const Parameter = new Dropdown({
    container: "#parameter",
    elementExists: true,
    onChange: () => {
      updateData();
    },
  });

  // create the flow conditions filter
  const FlowConditions = new Dropdown({
    container: "#flow-conditions",
    elementExists: true,
    onChange: () => {
      updateData();
    },
  });

  // create the flow conditions filter
  const Season = new Dropdown({
    container: "#season",
    elementExists: true,
    onChange: () => {
      updateData();
    },
  });

  // create the Upstream to Downstream concentrations graph
  const UDConcentrationsGraph = new ScatterChart({
    container: "#upstream-downstream-concentrations",
    heightScale: 0.4,
    widthScale: 1,
    xAxis: {
      field: "rdate",
      format: "MM/YY",
      scale: "scaleTime",
    },
    yAxis: {
      field: "rvalue_converted",
      scale: "scaleLinear",
      unitsField: "unit_name",
    },
    series: [
      {
        color: "#5c6bc0",
        field: "location_name",
        value: activePRFLocs.upstreamLoc,
        secondaryField: "flow_conditions_display",
        secondaryValue: "Baseflow",
        hollow: false,
      },
      {
        color: "#5c6bc0",
        field: "location_name",
        value: activePRFLocs.upstreamLoc,
        secondaryField: "flow_conditions_display",
        secondaryValue: "Stormflow",
        hollow: true,
      },
      {
        color: "#23b578",
        field: "location_name",
        value: activePRFLocs.downstreamLoc,
        secondaryField: "flow_conditions_display",
        secondaryValue: "Baseflow",
        hollow: false,
      },
      {
        color: "#23b578",
        field: "location_name",
        value: activePRFLocs.downstreamLoc,
        secondaryField: "flow_conditions_display",
        secondaryValue: "Stormflow",
        hollow: true,
      },
    ],
  });

  // create the net change (concentration) graph
  const UDNetChangeGraph = new ScatterChart({
    container: "#upstream-downstream-net-change",
    heightScale: 0.4,
    widthScale: 1,
    zeroLine: true,
    xAxis: {
      field: "rdate",
      format: "MM/YY",
      scale: "scaleTime",
    },
    yAxis: {
      field: "net_change",
      scale: "scaleLinear",
      unitsField: "net_change_units",
    },
    series: [
      {
        color: "#2895fd",
        field: "flow_conditions_display",
        value: "Baseflow",
        hollow: false,
      },
      {
        color: "#2895fd",
        field: "flow_conditions_display",
        value: "Stormflow",
        hollow: true,
      },
    ],
  });

  // create the net change (%) graph
  const UDPercentChangeGraph = new ScatterChart({
    container: "#upstream-downstream-percent-change",
    heightScale: 0.4,
    widthScale: 1,
    zeroLine: true,
    xAxis: {
      field: "rdate",
      format: "MM/YY",
      scale: "scaleTime",
    },
    yAxis: {
      field: "percent_change",
      scale: "scaleLinear",
      unitsField: "percent_change_units",
    },
    series: [
      {
        color: "#2895fd",
        field: "flow_conditions_display",
        value: "Baseflow",
        hollow: false,
      },
      {
        color: "#2895fd",
        field: "flow_conditions_display",
        value: "Stormflow",
        hollow: true,
      },
    ],
  });

  /**
   * This function is used to prepare/filter the data based
   * on the active filters
   * Returns the filtered results
   * @param {object} filterVals filter values to apply
   * @param {array} data data to filter
   */
  function setNewGraphData(filterVals, data) {
    const newData = data
      .filter(d => {
        const rdate = new Date(`${d.rdate} 00:00:00`);
        const startDate = new Date(`${StartDate.getDate()} 00:00:00`);
        const endDate = new Date(`${EndDate.getDate()} 00:00:00`);
        return rdate >= startDate && rdate <= endDate;
      })
      .filter(d => d.parameterid == filterVals.parameter)
      .filter(d => d.groupid == filterVals.prfGroup)
      .filter(d =>
        filterVals.flow_conditions.includes(d.flow_conditions_display)
      )
      .filter(d => filterVals.seasonid.includes(d.seasonid));
    return newData;
  }

  /**
   * This function is used to update the graph and summary stats table
   * whenever any of the filters change.
   */
  function updateData() {
    const filterVals = {
      start_date: StartDate.getDate(),
      end_date: EndDate.getDate(),
      prfGroup: PRFs.val(),
      parameter: Parameter.val(),
      flow_conditions:
        FlowConditions.text() === "All Flow"
          ? ["Stormflow", "Baseflow"]
          : [FlowConditions.text()],
      flow_conditions:
        FlowConditions.text() === "All Flow"
          ? ["Stormflow", "Baseflow"]
          : [FlowConditions.text()],
      seasonid: Season.val() == 999 ? [10, 11] : Season.val(),
    };

    if (UDGraphData.length > 0) {
      const newData = setNewGraphData(filterVals, UDGraphData);

      const upstreamData = newData.filter(d => d.endpoint_desc === "Upstream");
      const downstreamData = newData.filter(
        d => d.endpoint_desc === "Downstream"
      );

      activePRFLocs.upstreamLoc =
        upstreamData.length > 0 ? upstreamData[0].location_name : "";
      activePRFLocs.downstreamLoc =
        downstreamData.length > 0 ? downstreamData[0].location_name : "";

      (UDConcentrationsGraph.series = [
        {
          color: "#5c6bc0",
          field: "location_name",
          value: activePRFLocs.upstreamLoc,
          secondaryField: "flow_conditions_display",
          secondaryValue: "Baseflow",
          hollow: false,
        },
        {
          color: "#5c6bc0",
          field: "location_name",
          value: activePRFLocs.upstreamLoc,
          secondaryField: "flow_conditions_display",
          secondaryValue: "Stormflow",
          hollow: true,
        },
        {
          color: "#23b578",
          field: "location_name",
          value: activePRFLocs.downstreamLoc,
          secondaryField: "flow_conditions_display",
          secondaryValue: "Baseflow",
          hollow: false,
        },
        {
          color: "#23b578",
          field: "location_name",
          value: activePRFLocs.downstreamLoc,
          secondaryField: "flow_conditions_display",
          secondaryValue: "Stormflow",
          hollow: true,
        },
      ]),
        UDConcentrationsGraph.setData(newData);
      UDConcentrationsGraph.draw();

      createUDStatsTable(
        "#ud-stats-table",
        statTableConfig,
        calcUDStats(newData)
      );
      setGraphTitle(newData[0].unit_name);
      setLegend();
    }

    if (UDNetChangeGraphData.length > 0) {
      const newData = setNewGraphData(filterVals, UDNetChangeGraphData);
      UDNetChangeGraph.setData(newData);
      UDNetChangeGraph.draw();
    }

    if (UDPercentChangeGraphData.length > 0) {
      const newData = setNewGraphData(filterVals, UDPercentChangeGraphData);
      UDPercentChangeGraph.setData(newData);
      UDPercentChangeGraph.draw();
    }
  }

  // retrieve the parameters list from the DB
  const parameterPromise = fetchData(
    "/sites/all/scripts/activeDataFilters.php?table=viewer.nonbio_dropdown_params&fields%5B%5D=*&sort=&drupal_userid=1&drupal_user_switch=false"
  );

  const seasonsPromise = fetchData(
    "/sites/all/scripts/activeDataFilters.php?table=data_import.list_seasons_dropdown&fields%5B%5D=*&sort=&drupal_userid=1&drupal_user_switch=false"
  );

  // retrieve the PRFs group list from the DB
  const prfsPromise = fetchData(
    "/sites/all/scripts/activeDataFilters.php?table=viewer.prf_list_location_groups_dropdown&fields%5B%5D=*&sort=&drupal_userid=1&drupal_user_switch=false"
  );

  // retrieve the flow conditions list from the DB
  const flowConditionsPromise = fetchData(
    "/sites/all/scripts/activeDataFilters.php?table=data_import.list_flow_conditions_dropdown&fields%5B%5D=*&sort=&drupal_userid=1&drupal_user_switch=false"
  );

  // retrieve the data for the graphs from the DB
  const UDGraphDataPromise = fetchData(
    "/sites/all/scripts/activeDataFilters.php?table=viewer.prf_performance_data&fields%5B%5D=*&sort=&drupal_userid=1&drupal_user_switch=false"
  );

  const UDAnalysisGraphDataPromise = fetchData(
    "/sites/all/scripts/activeDataFilters.php?table=viewer.prf_performance_data_analysis&fields%5B%5D=*&sort=&drupal_userid=1&drupal_user_switch=false"
  );

  // Populate the parameter dropdown after request resolves
  // filter the dropdown list to only params that are relevant
  // to the PRFs
  parameterPromise
    .then(data => {
      const parameters = [28, 46, 47, 29, 27, 50, 53, 30];
      Parameter.data = data.filter(d => parameters.includes(d.stored));
      Parameter.buildDropdown().val(28);
    })
    .catch(err => {
      console.error(err);
    });

  // Populate the PRFs dropdown after request resolves
  prfsPromise
    .then(data => {
      PRFs.data = data.filter(record => record.list_ndx == 129);
      PRFs.buildDropdown().val(129);
    })
    .catch(err => {
      console.error(err);
    });

  // Populate the PRFs dropdown after request resolves
  seasonsPromise
    .then(data => {
      Season.data = data;
      Season.data.push({ list_ndx: 999, list_display: "Annual" });
      Season.buildDropdown().val(999);
    })
    .catch(err => {
      console.error(err);
    });

  // Populate the flow conditions dropdown after request resolves
  // add a dropdown option for 'all flow' that captures base and storm flow
  flowConditionsPromise
    .then(data => {
      FlowConditions.data = data.filter(d => [1, 2].includes(d.list_ndx));
      FlowConditions.data.push({ list_ndx: 999, list_display: "All Flow" });
      FlowConditions.buildDropdown().val(999);
    })
    .catch(err => {
      console.error(err);
    });

  // once graph data is returned from the DB
  // filter it to match the initial filter selections
  // create graph and summary stats table from filtered data
  UDGraphDataPromise.then(data => {
    UDGraphData = data;
    const initData = data
      .filter(d => d.groupid === 129)
      .filter(d => {
        const rdate = new Date(`${d.rdate} 00:00:00`);
        const startDate = new Date(`${StartDate.getDate()} 00:00:00`);
        const endDate = new Date(`${EndDate.getDate()} 00:00:00`);
        return rdate >= startDate && rdate <= endDate;
      })
      .filter(d => d.parameterid === 28);
    UDConcentrationsGraph.setData(initData);
    UDConcentrationsGraph.draw();

    createUDStatsTable(
      "#ud-stats-table",
      statTableConfig,
      calcUDStats(initData)
    );
    setGraphTitle(initData[0].unit_name);
    setLegend();
    resizeSidebar();
  });

  UDAnalysisGraphDataPromise.then(data => {
    UDNetChangeGraphData = data;
    const initData_net = data
      .filter(d => d.groupid === 129)
      .filter(d => {
        const rdate = new Date(`${d.rdate} 00:00:00`);
        const startDate = new Date(`${StartDate.getDate()} 00:00:00`);
        const endDate = new Date(`${EndDate.getDate()} 00:00:00`);
        return rdate >= startDate && rdate <= endDate;
      })
      .filter(d => d.parameterid === 28);
    UDNetChangeGraph.setData(initData_net);
    UDNetChangeGraph.draw();

    UDPercentChangeGraphData = data;
    const initData_per = data
      .filter(d => d.groupid === 129)
      .filter(d => {
        const rdate = new Date(`${d.rdate} 00:00:00`);
        const startDate = new Date(`${StartDate.getDate()} 00:00:00`);
        const endDate = new Date(`${EndDate.getDate()} 00:00:00`);
        return rdate >= startDate && rdate <= endDate;
      })
      .filter(d => d.parameterid === 28);
    UDPercentChangeGraph.setData(initData_per);
    UDPercentChangeGraph.draw();
    resizeSidebar();
  }).catch(err => {
    console.error(err);
  });
};
